export default __webpack_public_path__ + "static/media/AtharvaMahajan.5be8182d.png";